/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValueWithNote
 */
export interface ValueWithNote {
    /**
     * 
     * @type {string}
     * @memberof ValueWithNote
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof ValueWithNote
     */
    note?: string;
}

/**
 * Check if a given object implements the ValueWithNote interface.
 */
export function instanceOfValueWithNote(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ValueWithNoteFromJSON(json: any): ValueWithNote {
    return ValueWithNoteFromJSONTyped(json, false);
}

export function ValueWithNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValueWithNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function ValueWithNoteToJSON(value?: ValueWithNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'note': value.note,
    };
}

